import React from 'react';
import { vendorRspReport } from '../../actions/invoiceDateActions';
import ResponseReportView from './ResponseReportView';

const VendorResponseReport = () => (
    <ResponseReportView
        stateKey="vendorspReport"
        resetType="VENDOR_REPORT_RESET"
        fetchReport={vendorRspReport}
        showLate
        filePrefix="Response_Report"
    />
);

export default VendorResponseReport;
